import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './app-modules/chat/chat.component';
import { DisableMailNotificationsComponent } from './app-modules/disable-mail-notifications/disable-mail-notifications.component';
import { HomeComponent } from './app-modules/home/home.component';

import { LoginComponent } from './app-modules/login/login.component';
import { LogoutComponent } from './app-modules/logout/logout.component';
import { PrivacyPolicyComponent } from './app-modules/privacy-policy/privacy-policy.component';
import { ProfileComponent } from './app-modules/profile/profile.component';
import { RegisterComponent } from './app-modules/register/register.component';
import { UserSetupComponent } from './app-modules/user-setup/user-setup.component';
import { WelcomePageComponent } from './app-modules/welcome-page/welcome-page.component';
import { AuthGaurdService } from './service/auth-gaurd.service';
import { SetupGuardService } from './service/setup-guard.service';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthGaurdService] },
  { path: 'register', component: RegisterComponent },
  { path: 'chat', component: ChatComponent, canActivate: [AuthGaurdService, SetupGuardService] },
  { path: 'setup', component: UserSetupComponent, canActivate: [AuthGaurdService] },
  { path: 'home', component: HomeComponent, canActivate: [AuthGaurdService, SetupGuardService] },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGaurdService, SetupGuardService] },
  { path: 'disableNotifications', component: DisableMailNotificationsComponent},
  { path: 'policy', component: PrivacyPolicyComponent},
  { path: '', component: WelcomePageComponent},
  { path: '**', redirectTo: '/chat', pathMatch: 'full'}


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
